export type StoredDurationFlags = {
  isDurationStartNow: boolean;
  isDurationEndOpen: boolean;
};

const storageKey = (jobId: string) => `bn-job-duration-flags:${jobId}`;

export function readStoredDurationFlags(
  jobId: string
): StoredDurationFlags | null {
  try {
    const raw = sessionStorage.getItem(storageKey(jobId));
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredDurationFlags;
    return {
      isDurationStartNow: !!parsed.isDurationStartNow,
      isDurationEndOpen: !!parsed.isDurationEndOpen,
    };
  } catch {
    return null;
  }
}

export function writeStoredDurationFlags(
  jobId: string,
  flags: StoredDurationFlags
): void {
  sessionStorage.setItem(storageKey(jobId), JSON.stringify(flags));
}

export function resolveSubstituteDurationFlags(
  jobId: string,
  hasFromDate: boolean,
  hasToDate: boolean,
  isPublished: boolean
): StoredDurationFlags {
  const stored = readStoredDurationFlags(jobId);
  if (stored) {
    return stored;
  }
  // Both null on a draft = not yet configured; avoid falsely marking Zeitraum as
  // complete. A published posting went through the Zeitraum step, so both null
  // there means "Ab sofort - auf Weiteres" (as 2Weeks/PHZH render it).
  if (!hasFromDate && !hasToDate && !isPublished) {
    return { isDurationStartNow: false, isDurationEndOpen: false };
  }
  // Backend has no boolean flag for open-ended dates — convention: null `from_date`
  // means "Ab sofort", null `to_date` means "Bis auf Weiteres" for substitute jobs.
  return {
    isDurationStartNow: !hasFromDate,
    isDurationEndOpen: !hasToDate,
  };
}
